
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/[projectSlug]/free-ticket-terms",
      function () {
        return require("private-next-pages/[locale]/legal/[projectSlug]/free-ticket-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/[projectSlug]/free-ticket-terms"])
      });
    }
  